import { render, staticRenderFns } from "./TeamCreato.vue?vue&type=template&id=1b77aa1e&scoped=true"
import script from "./TeamCreato.vue?vue&type=script&lang=js"
export * from "./TeamCreato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b77aa1e",
  null
  
)

export default component.exports